import { SupportedLocales } from '@/models/localization.model';
import { IPhotosOrder, IUpdateProductMainInfoDTO } from '@/models/products.model';
import {
  ProductMainInfoFormFieldsNames,
  TProductMainInfoFormValues,
  getNewAddedFiles,
  getNewAddedFilesIds,
  getProductPhotosOrdersList,
  MeasureUnitCode,
} from '../helpers';

class UpdateProductMainInfoDTO implements IUpdateProductMainInfoDTO {
  locale: { [key in SupportedLocales]: { name: string; description: string; original_name?: string | null } };
  slug?: string;
  external_id?: string;
  uktzed?: string;
  imported?: '0' | '1';
  is_custom_order?: '0' | '1';
  weight?: number;
  length?: number;
  height?: number;
  width?: number;
  photos?: File[];
  photo_ids?: string[];
  order: IPhotosOrder[];
  unit_code?: MeasureUnitCode;
  package_quantity?: number;
  min_order_packages?: number;

  constructor(values: TProductMainInfoFormValues) {
    this.slug = values[ProductMainInfoFormFieldsNames.SLUG];
    this.external_id = values[ProductMainInfoFormFieldsNames.EXTERNAL_ID];
    this.locale = values[ProductMainInfoFormFieldsNames.LOCALE];
    this.uktzed = values[ProductMainInfoFormFieldsNames.UKTZED];
    this.imported = !!values[ProductMainInfoFormFieldsNames.IMPORTED] ? '1' : '0';
    this.is_custom_order = !!values[ProductMainInfoFormFieldsNames.IS_CUSTOM_ORDER] ? '1' : '0';
    this.weight = values[ProductMainInfoFormFieldsNames.WEIGHT];
    this.length = values[ProductMainInfoFormFieldsNames.LENGTH];
    this.height = values[ProductMainInfoFormFieldsNames.HEIGHT];
    this.width = values[ProductMainInfoFormFieldsNames.WIDTH];
    this.photos = getNewAddedFiles(values[ProductMainInfoFormFieldsNames.PHOTOS]);
    this.photo_ids = getNewAddedFilesIds(values[ProductMainInfoFormFieldsNames.PHOTOS]);
    this.order = getProductPhotosOrdersList(values[ProductMainInfoFormFieldsNames.PHOTOS]);
    this.unit_code = values[ProductMainInfoFormFieldsNames.UNIT_CODE];
    this.package_quantity = values[ProductMainInfoFormFieldsNames.PACKAGE_QUANTITY];
    this.min_order_packages = values[ProductMainInfoFormFieldsNames.MIN_ORDER_PACKAGES];
  }
}

export default UpdateProductMainInfoDTO;
